//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DebounceRepeaterChildChanges: FeatureFlag = {"Id":"DebounceRepeaterChildChanges","Label":"[10.18]DebounceRepeaterChildChanges","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Debounce repeater child updates to reduce rendering churn.","Mode":0,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
